/**
 * PourQui — segmentation par taille d'église, 4 cards.
 */
import { Link } from "react-router-dom";
import { colors, fonts } from "../../styles/tokens";
import Button from "../Button";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const SEGMENTS = [
  {
    icon: "🏠",
    titre: "Cellule de maison",
    taille: "5-20 membres",
    prix: "Gratuit pour toujours.",
    plan: "Freemium",
    accent: "#60A5FA",
  },
  {
    icon: "⛪",
    titre: "Petite église",
    taille: "20-200 membres",
    prix: "Dès 14,99 €/mois ou 9 900 FCFA/mois.",
    plan: "Communauté",
    accent: colors.gold,
  },
  {
    icon: "🏛",
    titre: "Grande église",
    taille: "200-1000 membres",
    prix: "Dès 29,99 €/mois · Équipes + Exports.",
    plan: "Starter",
    accent: "#A78BFA",
  },
  {
    icon: "🌍",
    titre: "Réseau d'églises",
    taille: "1000+ membres",
    prix: "Dès 79,99 €/mois · Tout inclus.",
    plan: "Pro",
    accent: "#2DD4A0",
  },
];

export default function PourQui() {
  const [titleRef, titleStyle] = useScrollFadeIn();

  return (
    <section style={{
      padding: "clamp(64px, 10vw, 100px) clamp(16px, 4vw, 24px)",
      background: colors.bg, fontFamily: fonts.body,
      maxWidth: "100vw", overflowX: "hidden",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <h2 ref={titleRef} style={{
          ...titleStyle,
          fontFamily: fonts.heading,
          fontSize: "clamp(32px, 4vw, 48px)",
          fontWeight: 700,
          textAlign: "center",
          color: colors.text,
          marginBottom: "12px",
          letterSpacing: "-0.01em",
        }}>
          Pour chaque église,<br />
          <span style={{ color: colors.gold }}>quelle que soit sa taille.</span>
        </h2>
        <p style={{
          color: colors.textMuted, fontSize: "16px",
          textAlign: "center", maxWidth: 600, margin: "0 auto 56px", lineHeight: 1.6,
        }}>
          De la cellule de maison au réseau international, un plan adapté à votre réalité.
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "16px",
        }}>
          {SEGMENTS.map((s, i) => (
            <Segment key={s.titre} item={s} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Segment({ item, delay }) {
  const [ref, style] = useScrollFadeIn({ delay });
  return (
    <div ref={ref} style={{
      ...style,
      padding: "28px 22px",
      background: colors.card,
      border: `1px solid ${colors.border}`,
      borderRadius: "16px",
      borderTop: `4px solid ${item.accent}`,
      display: "flex",
      flexDirection: "column",
    }}>
      <div style={{ fontSize: "36px", marginBottom: "12px" }}>{item.icon}</div>
      <h3 style={{
        fontFamily: fonts.heading,
        fontSize: "20px",
        fontWeight: 600,
        color: colors.text,
        marginBottom: "4px",
      }}>
        {item.titre}
      </h3>
      <div style={{ color: item.accent, fontSize: "13px", fontWeight: 600, marginBottom: "12px" }}>
        {item.taille}
      </div>
      <p style={{ color: colors.textMuted, fontSize: "13px", lineHeight: 1.6, flex: 1, marginBottom: "16px" }}>
        {item.prix}
      </p>
      <Link to="/inscription" style={{ textDecoration: "none" }}>
        <Button variant="ghost" size="sm" fullWidth>
          Commencer →
        </Button>
      </Link>
    </div>
  );
}
